import { render, staticRenderFns } from "./SlidingBaySizeAndGlazing.vue?vue&type=template&id=ad984bb4&scoped=true"
import script from "./SlidingBaySizeAndGlazing.vue?vue&type=script&lang=ts"
export * from "./SlidingBaySizeAndGlazing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad984bb4",
  null
  
)

export default component.exports